module.exports = __webpack_public_path__ + "media/images/articles/resignation/img02-46143d0b80ffa634748ea42750b4f212.png";